var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrame87(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292892 5.29289C-0.0976319 5.68342 -0.097632 6.31658 0.292892 6.70711C0.683416 7.09763 1.31658 7.09763 1.70711 6.70711L0.292892 5.29289ZM6 1L6.70711 0.292894C6.31658 -0.0976302 5.68342 -0.0976303 5.29289 0.292894L6 1ZM10.2929 6.70711C10.6834 7.09763 11.3166 7.09763 11.7071 6.70711C12.0976 6.31658 12.0976 5.68342 11.7071 5.2929L10.2929 6.70711ZM1.70711 6.70711L6.70711 1.70711L5.29289 0.292894L0.292892 5.29289L1.70711 6.70711ZM5.29289 1.70711L10.2929 6.70711L11.7071 5.2929L6.70711 0.292894L5.29289 1.70711Z",
    fill: "#00FF75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13L6 1",
    stroke: "#00FF75",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame87);
export default __webpack_public_path__ + "static/media/Frame 87.4fb3138ed4e3954b21370035af18f278.svg";
export { ForwardRef as ReactComponent };